import { CommentItemType } from "../../../../../../createEscalation.models";

export const isTypeDraftComment = (type: CommentItemType): boolean => {
    return type === CommentItemType.DRAFT_COMMENT;
}

export const isTypeStatusChanged = (type: CommentItemType): boolean => {
    return type === CommentItemType.STATUS_CHANGED;
}

export const isTypeEscalationRaised = (type: CommentItemType): boolean => {
    return type === CommentItemType.ESCALATION_RAISED;
}

export const isTypeEmailSent = (type: CommentItemType): boolean => {
    return type === CommentItemType.EMAIL_SENT;
}

export const isCommentEditable = (type: CommentItemType, onContentChange?: (value: string) => void): boolean => {
    return type === CommentItemType.DRAFT_COMMENT && !!onContentChange;
}
